import styled from '@emotion/styled';
import { Button, colors, Stack, Typography } from '@ui-components/neo.tax';

export interface StyledStackBadgeProps {
  $colorVariant: StackBadgeColorVariant;
  $isOpen?: boolean;
}

const STACK_BADGE_COLOR_VARIANTS: Record<string, { backgroundColor: string; color: string; border?: string }> = {
  default: {
    backgroundColor: colors.gray[200],
    color: colors.gray[800],
  },
  primary: {
    backgroundColor: colors.primary[200],
    color: colors.primary[800],
  },
  darkPrimary: {
    backgroundColor: colors.primary[600],
    color: colors.white,
  },
  secondary: {
    backgroundColor: colors.blue[200],
    color: colors.blue[800],
  },
  red: {
    backgroundColor: colors.rsbry[100],
    color: colors.rsbry[800],
  },
  yellow: {
    backgroundColor: colors.lemon[100],
    color: colors.lemon[800],
  },
  green: {
    backgroundColor: colors.green[100],
    color: colors.green[800],
  },
  blue: {
    backgroundColor: colors.blue[100],
    color: colors.blue[800],
  },
  darkGreen: {
    backgroundColor: colors.green[400],
    color: colors.white,
  },
  clear: {
    backgroundColor: colors.white,
    color: colors.gray[800],
    border: `1px solid ${colors.gray[300]}`,
  },
};

export type StackBadgeColorVariant = keyof typeof STACK_BADGE_COLOR_VARIANTS;

export const StyledStackBadge = styled(Stack)<StyledStackBadgeProps>(
  ({ $colorVariant }) => ({
    ...STACK_BADGE_COLOR_VARIANTS[$colorVariant],
    borderRadius: '0.375rem', // rounded-md equivalent
  }),
  ({ $isOpen }) =>
    $isOpen
      ? {
          borderTopLeftRadius: '0.375rem', // rounded-t-md equivalent
          borderTopRightRadius: '0.375rem',
          borderBottomLeftRadius: 0, // rounded-b-none equivalent
          borderBottomRightRadius: 0,
          zIndex: 10,
        }
      : {},
);

export const StyledTypographyLink = styled(Typography)({
  textDecoration: 'underline',
});

export const StyledTypographyMoreLessLink = styled(Typography)({
  textDecoration: 'underline',
  alignSelf: 'flex-end',
  cursor: 'pointer',
});

export type StyledTypographyLineClampProps = {
  $isExpanded: boolean;
  $numOfLines: number;
};

export const StyledTypographyLineClamp = styled(Typography)<StyledTypographyLineClampProps>(
  ({ $isExpanded, $numOfLines }) =>
    !$isExpanded
      ? {
          display: '-webkit-box',
          WebkitLineClamp: $numOfLines,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }
      : {},
);

export const StyledConfirmProjectDetailsButton = styled(Button)({
  margin: '20px 0 0 0',
});
